import { useMemo } from 'react';

import useCurrencies from '../../../../fetchHooks/useCurrencies';
import type { CurrencyItem } from '../../../../generated-types';
import { defaultRecommendedCurrencies } from '../currencyUtils';
import useFormContext from '../form/useFormContext';

const useUniqueCurrencies = () => {
    const { data: dataCurrencies, isLoading, error, refetch } = useCurrencies();
    const { state } = useFormContext();

    const countryCurrency = useMemo(
        () => dataCurrencies?.find((currency) => currency.currency === state.currency),
        [dataCurrencies, state.currency],
    );

    const recommendedCurrencies = useMemo(() => {
        return countryCurrency?.name
            ? [
                  ...defaultRecommendedCurrencies,
                  { currency: countryCurrency.currency.toString(), name: countryCurrency.name },
              ]
            : defaultRecommendedCurrencies;
    }, [countryCurrency]);

    const currencies = useMemo(() => {
        const targetCurrencies = [...recommendedCurrencies, ...(dataCurrencies ?? [])];
        return targetCurrencies?.reduce((result, currencyItem) => {
            if (!result.some((currency) => currency.currency === currencyItem.currency)) {
                result.push(currencyItem as CurrencyItem);
            }
            return result;
        }, [] as CurrencyItem[]);
    }, [dataCurrencies, recommendedCurrencies]);

    const eurCurrency = useMemo(
        () => currencies?.find((element) => element.currency.toString() === 'EUR'),
        [currencies],
    );

    return { isLoading, error, refetch, currencies, countryCurrency, eurCurrency };
};

export default useUniqueCurrencies;
